import React, { ComponentProps, FunctionComponent } from "react";

const CalenderIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 12",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M0 3.2H12V10.6C12 10.9713 11.8525 11.3274 11.5899 11.5899C11.3274 11.8525 10.9713 12 10.6 12H1.4C0.6272 12 0 11.3728 0 10.6V3.2ZM3.30711 8.29289C3.11957 8.10536 2.86522 8 2.6 8C2.33478 8 2.08043 8.10536 1.89289 8.29289C1.70536 8.48043 1.6 8.73478 1.6 9C1.6 9.26522 1.70536 9.51957 1.89289 9.70711C2.08043 9.89464 2.33478 10 2.6 10C2.86522 10 3.11957 9.89464 3.30711 9.70711C3.49464 9.51957 3.6 9.26522 3.6 9C3.6 8.73478 3.49464 8.48043 3.30711 8.29289ZM6.70711 8.29289C6.51957 8.10536 6.26522 8 6 8C5.73478 8 5.48043 8.10536 5.29289 8.29289C5.10536 8.48043 5 8.73478 5 9C5 9.26522 5.10536 9.51957 5.29289 9.70711C5.48043 9.89464 5.73478 10 6 10C6.26522 10 6.51957 9.89464 6.70711 9.70711C6.89464 9.51957 7 9.26522 7 9C7 8.73478 6.89464 8.48043 6.70711 8.29289ZM3.30711 5.09289C3.11957 4.90536 2.86522 4.8 2.6 4.8C2.33478 4.8 2.08043 4.90536 1.89289 5.09289C1.70536 5.28043 1.6 5.53478 1.6 5.8C1.6 6.06522 1.70536 6.31957 1.89289 6.50711C2.08043 6.69464 2.33478 6.8 2.6 6.8C2.86522 6.8 3.11957 6.69464 3.30711 6.50711C3.49464 6.31957 3.6 6.06522 3.6 5.8C3.6 5.53478 3.49464 5.28043 3.30711 5.09289ZM6.70711 5.09289C6.51957 4.90536 6.26522 4.8 6 4.8C5.73478 4.8 5.48043 4.90536 5.29289 5.09289C5.10536 5.28043 5 5.53478 5 5.8C5 6.06522 5.10536 6.31957 5.29289 6.50711C5.48043 6.69464 5.73478 6.8 6 6.8C6.26522 6.8 6.51957 6.69464 6.70711 6.50711C6.89464 6.31957 7 6.06522 7 5.8C7 5.53478 6.89464 5.28043 6.70711 5.09289ZM10.1071 5.09289C9.91957 4.90536 9.66522 4.8 9.4 4.8C9.13478 4.8 8.88043 4.90536 8.69289 5.09289C8.50536 5.28043 8.4 5.53478 8.4 5.8C8.4 6.06522 8.50536 6.31957 8.69289 6.50711C8.88043 6.69464 9.13478 6.8 9.4 6.8C9.66522 6.8 9.91957 6.69464 10.1071 6.50711C10.2946 6.31957 10.4 6.06522 10.4 5.8C10.4 5.53478 10.2946 5.28043 10.1071 5.09289ZM1.4 0H10.6C10.9713 0 11.3274 0.1475 11.5899 0.41005C11.8525 0.672601 12 1.0287 12 1.4V2H0V1.4C0 1.0287 0.1475 0.672601 0.41005 0.41005C0.672601 0.1475 1.0287 0 1.4 0Z",
    })
  );
};

const ForwardRef = React.forwardRef(CalenderIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
